import { connect } from 'react-redux';
import PageCounter from './pageCounter';

const mapStateToProps = state => ({
  activePageIndex: state.activePageIndex,
  totalPages: state.pdfDocument && state.pdfDocument.numPages,
});

export default connect(mapStateToProps)(PageCounter);
